export const iconFontAwesomeHumanitarianTarp = (
	<i className="fa-solid fa-tarp"></i>
);
